<template>
    <div class="flex">
        <div v-for="(item, index) in items" :key="index">
            <div class="divider inline-block bg-indigo-50" v-if="item.type === 'divider'" />
            <MenuItem v-else v-bind="item" />
        </div>
    </div>
</template>

<script>
import MenuItem from '@/components/Forms/RichTextEditor/MenuItem.vue';

export default {
    components: {
        MenuItem,
    },

    props: {
        editor: {
            type: Object,
            required: true,
        },
        only: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    methods: {
        setLink() {
            const previousUrl = this.editor.getAttributes('link').href;
            const url = window.prompt('URL', previousUrl);
            // cancelled
            if (url === null) {
                return;
            }
            // empty
            if (url === '') {
                this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
                return;
            }
            // update link
            this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        },
    },
    computed: {
        items: function () {
            if (this.only.length === 0) {
                return this.elements;
            }

            return this.elements.filter((e) => {
                return this.only.includes(e.icon);
            });
        },
    },
    data() {
        return {
            elements: [
                {
                    icon: 'bold',
                    title: 'Bold',
                    action: () => this.editor.chain().focus().toggleBold().run(),
                    isActive: () => this.editor.isActive('bold'),
                },
                {
                    icon: 'italic',
                    title: 'Italic',
                    action: () => this.editor.chain().focus().toggleItalic().run(),
                    isActive: () => this.editor.isActive('italic'),
                },
                // {
                //     icon: 'mark-pen-line',
                //     title: 'Highlight',
                //     action: () => this.editor.chain().focus().toggleHighlight().run(),
                //     isActive: () => this.editor.isActive('highlight'),
                // },
                {
                    type: 'divider',
                },
                {
                    icon: 'h-1',
                    title: 'Heading 1',
                    action: () => this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
                    isActive: () => this.editor.isActive('heading', { level: 1 }),
                },
                {
                    icon: 'h-2',
                    title: 'Heading 2',
                    action: () => this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
                    isActive: () => this.editor.isActive('heading', { level: 2 }),
                },
                {
                    icon: 'text',
                    title: this.$t('messages.normal_text'),
                    action: () => this.editor.chain().focus().setParagraph().run(),
                    isActive: () => this.editor.isActive('paragraph'),
                },
                {
                    type: 'divider',
                },
                {
                    icon: 'list-unordered',
                    title: 'Bullet List',
                    action: () => this.editor.chain().focus().toggleBulletList().run(),
                    isActive: () => this.editor.isActive('bulletList'),
                },
                {
                    icon: 'list-ordered',
                    title: 'Ordered List',
                    action: () => this.editor.chain().focus().toggleOrderedList().run(),
                    isActive: () => this.editor.isActive('orderedList'),
                },
                // {
                //     icon: 'list-check-2',
                //     title: 'Task List',
                //     action: () => this.editor.chain().focus().toggleTaskList().run(),
                //     isActive: () => this.editor.isActive('taskList'),
                // },
                // {
                //     icon: 'code-box-line',
                //     title: 'Code Block',
                //     action: () => this.editor.chain().focus().toggleCodeBlock().run(),
                //     isActive: () => this.editor.isActive('codeBlock'),
                // },
                {
                    type: 'divider',
                },
                // {
                //     icon: 'double-quotes-l',
                //     title: 'Blockquote',
                //     action: () => this.editor.chain().focus().toggleBlockquote().run(),
                //     isActive: () => this.editor.isActive('blockquote'),
                // },
                {
                    icon: 'separator',
                    title: 'Horizontal Rule',
                    action: () => this.editor.chain().focus().setHorizontalRule().run(),
                },
                {
                    type: 'divider',
                },
                // {
                //     icon: 'text-wrap',
                //     title: 'Hard Break',
                //     action: () => this.editor.chain().focus().setHardBreak().run(),
                // },
                {
                    icon: 'format-clear',
                    title: 'Clear Format',
                    action: () => this.editor.chain().focus().clearNodes().unsetAllMarks().run(),
                },
                {
                    type: 'divider',
                },
                {
                    icon: 'arrow-go-back-line',
                    title: 'Undo',
                    action: () => this.editor.chain().focus().undo().run(),
                },
                // {
                //     icon: 'arrow-go-forward-line',
                //     title: 'Redo',
                //     action: () => this.editor.chain().focus().redo().run(),
                // },
                {
                    type: 'divider',
                },
                {
                    icon: 'link',
                    title: 'Link',
                    action: this.setLink,
                    isActive: () => this.editor.isActive('link'),
                },
                {
                    icon: 'unlink',
                    title: 'Unlink',
                    action: () => this.editor.chain().focus().unsetLink().run(),
                    isActive: () => !this.editor.isActive('link'),
                },
            ],
        };
    },
};
</script>

<style scoped>
.divider {
    width: 2px;
    height: 1.25rem;
    /*background-color: rgba($colorBlack, 0.1);*/
    margin-left: 0.5rem;
    margin-right: 0.75rem;
}
</style>
